import React from "react";
import "./schoolDirectorSection.css";
import school_director from "../../assets/images/school_director.jpg";

const SchoolDirectorSection = () => {
  return (
    <div className="teamProcess-FamGen">
      <div className="team_genFlex">
        {" "}
        <div className="team_genOne">
          <div className="team_genImg">
            <img src={school_director} />
          </div>
          <div className="team_directHead">Mrs. Kafilat Olayiwola K</div>
          <div className="team_directPara">Director</div>
        </div>
        <div className="team_genTwo">
          Education is not just about imparting knowledge, but about preparing
          young minds to face the challenges of the world with confidence and
          resilience. As the director of this school, I am committed to
          providing our students with the best possible learning experience, one
          that fosters intellectual curiosity, critical thinking, and a love of
          lifelong learning. Together, let's empower the next generation to
          create a better world for all.
        </div>
      </div>
    </div>
  );
};

export default SchoolDirectorSection;
